import map from 'lodash/map'
import partition from 'lodash/partition'
import * as React from 'react'
import {H1, H2} from '@frontrow/console/src/components/typography'
import {Link} from '@frontrow/console/src/components/ui/link'
import {type ItemT} from '@frontrow/console/src/entities/models/item'

import ErrorAlert from '@frontrow/console/src/components/common/error-alert'
import ItemCard from './item-card'
import {Routes} from '@frontrow/console/src/routers/routes'
import * as style from './piggy-store.module.scss'

type Props = {
  items: Array<ItemT>
  error: string | undefined | null
}

export const DEFAULT_PIGGY_STORE_GRADE = 0
export const MATURE_PIGGY_STORE_GRADE = 6

export default function PiggyStore(props: Props): React.ReactElement {
  const {items, error} = props

  const groupedItems = partition(items, item => item.isHidden)
  const hiddenItemNodes = createItemNodes(groupedItems[0])
  const liveItemNodes = createItemNodes(groupedItems[1])

  const errorNode = error !== null && error !== undefined ? <ErrorAlert>{error}</ErrorAlert> : null

  return (
    <div>
      <H1>Manage Piggy Store</H1>
      {errorNode}
      <Link href={Routes.items.itemCreate()} reactRouter>
        Add Item
      </Link>
      <H2>Live Items</H2>
      <div className={style.items}>{liveItemNodes}</div>
      <H2>Hidden Items</H2>
      <div className={style.items}>{hiddenItemNodes}</div>
    </div>
  )
}

function createItemNodes(items: Array<ItemT>): Array<React.ReactElement> {
  return map(items, item => <ItemCard key={item.id} item={item} />)
}
